(() => {
  if (customElements.get('fa26-shop-the-look')) return;

  class Fa26ShopTheLook extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }

    init() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.toggle = this.querySelector('[data-fa26-toggle]');
      this.toggleButtons = Array.from(this.querySelectorAll('[data-fa26-target]'));
      this.groups = Array.from(this.querySelectorAll('[data-fa26-group]'));
      this.layers = Array.from(this.querySelectorAll('[data-fa26-layer]'));

      this.toggleButtons.forEach((button) => {
        button.addEventListener('click', () => this.setGroup(button.dataset.fa26Target), { signal });
      });

      const initialGroup = (this.toggle && this.toggle.dataset.active) || 'hers';
      this.setGroup(initialGroup);
    }

    setGroup(group) {
      if (!group) return;
      this.activeGroup = group;

      if (this.toggle) this.toggle.dataset.active = group;

      this.toggleButtons.forEach((button) => {
        const isActive = button.dataset.fa26Target === group;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      this.layers.forEach((layer) => {
        const isActive = layer.dataset.fa26Layer === group;
        layer.classList.toggle('is-active', isActive);
        layer.setAttribute('aria-hidden', String(!isActive));
      });

      this.groups.forEach((element) => {
        element.hidden = element.dataset.fa26Group !== group;
      });

      this.refreshVisibleCarousels();
    }

    refreshVisibleCarousels() {
      this.querySelectorAll('[data-fa26-group]:not([hidden]) fa26-carousel').forEach((carousel) => {
        if (typeof carousel.refresh === 'function') carousel.refresh();
      });
    }
  }

  customElements.define('fa26-shop-the-look', Fa26ShopTheLook);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('fa26-shop-the-look').forEach((element) => element.init());
  });
})();
